import { AppAlert } from '@components/antd';
import { useAppBanner } from './hooks/use-app-banner';
import { Trans } from 'react-i18next';

export const InsufficientBalanceSuspendedBanner = () => {
  const { handleNavigateToWallet } = useAppBanner();
  return (
    <AppAlert
      showIcon
      type="warning"
      message={
        <p>
          <Trans
            i18nKey="your_account_has_been_suspended_due_to_insufficient_balance_please_load_your_wallet_here"
            components={[
              <span key="wallet-link" className="cursor-pointer text-amber-700" onClick={handleNavigateToWallet}>
                {' '}
              </span>,
            ]}
          />
        </p>
      }
    />
  );
};
